export default {
  transactionPlayBooks: [],
  transactionPlayBook: undefined,
};
